"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13 5a1 1 0 10-2 0v6H5a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6V5z" } }] }, "name": "plus", "theme": "outlined" };
exports.default = PlusOutlined;
